export default __webpack_public_path__ + "static/media/play_push.5bf83dce.svg";